import packageJson from '../../package.json';

export default {
  okta: {
    baseUrl: 'https://tempus.oktapreview.com',
    issuer: 'ausudtd99sCgoQEf30h7',
    clientId: '0oa1xh8sgr2Fy1nhR0h8',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedClientIds: {
    clinicalPortal: '0oa124s4klgJOa9nI0h8',
    lensNotebook: '0oaqegazqdyP0Jhuy0h7',
    lensNotebook2: '0oamc9v0naJv40dpJ0h7',
    lensGlass: '0oaeqck2ljsd5rnfB0h7',
    accountUi: '0oa1xh8sgr2Fy1nhR0h8',
    nextIntelligence: '0oay8x02x9opXbl9O0h7',
    nextPlatform: '0oay76aqq81grAMlV0h7',
    trialsApp: '0oay762v4jqeucIXU0h7',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedIssuerIds: {
    default: 'ausudtd99sCgoQEf30h7',
    demo: 'ausljcfleg4KQAT5C0h7',
    stagingDemo: 'ausigvgms1mmEKe8Q0h7',
  },
  apps: {
    clinicalPortal: 'https://hub.devtempus.com',
    lens: 'https://lens.stagingtempus.com',
    pixelRad: 'https://pixel-rad.devtempus.com',
    nextIntelligence: 'https://next-intelligence.devtempus.com',
    nextPlatform: 'https://next-platform.devtempus.com',
    providerAccount: 'https://provider-account.stagingtempus.com',
    trialsApp: 'https://trials.stagingtempus.com/',
    ehrIntegrationService: 'https://ehr-integration-service.devtempus.com',
    david: 'https://david.devtempus.com',
  },
  sentry: {
    dsn: 'https://9f8e11e5fbfa4b40b3d703fc2b8e847f@o816116.ingest.sentry.io/4504730124288000',
    environment: 'alp',
    enabled: true,
    release: `${packageJson.name}@${packageJson.version}`,
  },
  // Okta OIDC IdP "Tempus Auth0 Providers - Alp" → login.devtempus.com
  auth0: {
    oktaIdpId: '0oa2rntk1pot0Wxar0h8',
    sessionInitDomain: 'login.devtempus.com',
    sessionInitClientId: 'Hu69BaK6isYo2Tbf6vskUneIGp1ZfyRG',
    sessionInitConnection: 'TempusAI-WIC',
  },
  whitelistedRedirectDomain: [
    '.stagingtempus.com',
    '.alp.gcp.tempus.cloud',
    '.bet.gcp.tempus.cloud',
    '.devtempus.com:3001',
    '.devtempus.com',
    '.demotempus.com',
    'localhost:3000',
    'localhost:4470',
    '.devtempus.com:4470',
    '.devtempus.com',
    'localhost',
    '.dev.tempus.local',
  ],
};
